import { 
    UPDATE_ANNUAL_STATEMENT_DOCUMENTS, 
    UPDATE_COMPILANCE_OPINIONS_DOCUMENTS, 
    UPDATE_LEGAL_ENTITIE_DOCUMENTS, UPDATE_NATURAL_PERSON_DOCUMENTS, 
    UPDATE_PROVISIONAL_PAYMENTS_DOCUMENTS 
} from "../api/apiEmpresas";

export const UPDATE_DOCUMENT_BY_TABLA = {
    archivo_permanente: {
        LegalEntitie: UPDATE_LEGAL_ENTITIE_DOCUMENTS,
        NaturalPerson: UPDATE_NATURAL_PERSON_DOCUMENTS
    },
    opiniones_cumplimiento: UPDATE_COMPILANCE_OPINIONS_DOCUMENTS,
    declaracion_anual: UPDATE_ANNUAL_STATEMENT_DOCUMENTS,
    pagos_provicionales: UPDATE_PROVISIONAL_PAYMENTS_DOCUMENTS
};